import React, { Component } from "react";
import VacationProcessForm from "../VacationProcessForm/VacationProcessForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : VacationProcessPage
Description : Componente que contienen el formulario de la pantalla VacationProcess 
Date Autor Modification
================================================================================
06/10/2023 Santiago Coca – Se llama al componente VacationProcessForm
================================================================================ */
class VacationProcessPage extends Component {
    render() {
        return (
            <div>
                <VacationProcessForm />
            </div>
        )
    }
}

export default VacationProcessPage;